import React, { Component } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

import IconMap from '../../assets/icons/map.svg'
import IconMapWhite from '../../assets/icons/map-white.svg'
import IconArrowLeft from '../../assets/icons/arrow-left.svg'
import AppLogo from '../../assets/icons/app-logo.svg'

const HeaderStyle = styled.div`
  position: absolute;
  top: 0;
  width: calc(100% - 40px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  padding: 0 20px;
  z-index: 9999;

  #appLogo {
    height: 17px;
  }

  div {
    display: inline-flex;
    align-items: center;

    img {
      height: 35px;
    }

    h5 {
      color: white;
      font-size: 0.9em;
      font-weight: 500;
    }

  }

  #offlineBadge {
    color: white;
    padding: 8px 12px;
    background-color: #f80b0b;
    border-radius: 7px;
  }

  @media screen and (max-width: 375px) {
    width: calc(100% - 24px);
    padding: 0 14px;
  }

  @media screen and (max-width: 320px) {
    width: calc(100% - 20px);
    padding: 0 10px;
  }
`;

export default class Header extends Component {
  componentDidMount = () => {
    if (this.props.location.pathname === '/mappa/') {
      document.querySelector('#header').style.display = 'none'
    }
  }
  
  render() {
    const specialPages = this.props.location.pathname === '/' || this.props.location.pathname === '/ozzero' || this.props.location.pathname === '/ozzero/' || this.props.location.pathname === '/download' || this.props.location.pathname === '/download/' || this.props.location.pathname === '/chi-siamo' || this.props.location.pathname === '/chi-siamo/' || this.props.location.pathname === '/credits' || this.props.location.pathname === '/credits/' || this.props.location.pathname === '/404' || this.props.location.pathname === '/404/';

    return (
      <HeaderStyle id="header">
        {specialPages ?
          <img id="appLogo" src={AppLogo} alt="Ozzero"/>
          // <h5 id="logo">Passi per Ozzero</h5>
        :
          <Link to="/" style={{cursor: 'pointer'}}>
            <div id="backBtnText">
              <img src={IconArrowLeft} alt=""/>
              <h5>Indietro</h5>
            </div>
          </Link>
        }
        {typeof window !== `undefined` && navigator.onLine ?
          <Mappa specialPages={specialPages}/>
        :
          <h5 id="offlineBadge">OFFLINE</h5>
        }
      </HeaderStyle>
    )
  }
}

const Mappa = ({specialPages}) => {
  return (
    <div>
      {specialPages ?
        <Link to="/mappa/">
          <img src={IconMap} alt="Mappa Icon" style={{height: '28px', cursor: 'pointer'}}/>
        </Link>
      :
        <Link to="/mappa/">
          <img src={IconMapWhite} alt="Mappa Icon" style={{height: '28px', cursor: 'pointer'}}/>
        </Link>
      }
    </div>
  )
}